﻿window.SearchFilter = (function () {
    let tagClicked = function () {
        document.getElementById('searchForm').submit();
    }

    return _ = {
        tagClicked: tagClicked
    }
})();


